import { PageHeaderTitleDropdownBlock } from 'cdk-radial';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { PaymentType } from 'common/constants';
import { useClient } from 'components/ClientProvider';
import { useURLs } from 'hooks';
import {
  getSelectedPaymentType,
  setSelectedPaymentType
} from 'pages/LandingPage/components/LandingPageHeader/slice';
import { messages } from 'pages/VendorsTablePage/messages';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  pathToDefaultPaymentTypeMap,
  WINDOW_POPUP_TARGET_SELF
} from './constants';
import { StyledPageHeaderWrapper } from './styled';
import { usePaymentTypeOptions } from './usePaymentTypeOptions';
import type { PageHeaderDropdownOption } from './types';

export const PageHeader = ({
  children
}: {
  children: React.JSX.Element | React.JSX.Element[];
}): React.JSX.Element => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const intl = useIntl();
  const urls = useURLs();

  const client = useClient();

  const selectedPaymentType = useAppSelector(getSelectedPaymentType);
  const dropdownOptions = usePaymentTypeOptions();
  const selectedDropdownOption = dropdownOptions.find(
    ({ id }) => id === selectedPaymentType
  );

  useEffect(() => {
    const pathname = `/${location.pathname.split('/').pop()}`;
    dispatch(setSelectedPaymentType(pathToDefaultPaymentTypeMap[pathname]));
  }, [dispatch, location.pathname]);

  const onSelect = ({ id }: PageHeaderDropdownOption) => {
    switch (id) {
      case PaymentType.OnDemand: {
        if (client?.isMFE) {
          history.push(urls.odcPage);
        } else {
          window.open(urls.odcPage, WINDOW_POPUP_TARGET_SELF);
        }
        break;
      }
      case PaymentType.Register: {
        if (client?.isMFE) {
          history.push(urls.registerPage);
        } else {
          window.open(urls.registerPage, WINDOW_POPUP_TARGET_SELF);
        }
        break;
      }
      default: {
        history.push(urls.landingPage);
        break;
      }
    }

    dispatch(setSelectedPaymentType(id));
  };

  return (
    <StyledPageHeaderWrapper data-testid="accounts-payable-page-header">
      <PageHeaderTitleDropdownBlock
        dataTestId="accounts-payable-page-header-title"
        onSelect={onSelect}
        options={dropdownOptions}
        selectedOption={{
          ...selectedDropdownOption,
          label: intl.formatMessage(messages.paymentsHeader, {
            workflow: selectedDropdownOption?.label
          })
        }}
      />
      {children}
    </StyledPageHeaderWrapper>
  );
};

export default PageHeader;
